import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import menue from './menue.json';
import { useLocation, useNavigate } from 'react-router-dom';
import Icons from '../../Constants/Icons';

function Menue() {
    const location = useLocation();
    const pathpart = location.pathname.split('/')[2] || "dashboard";
    const [selectedItem, setSelectedItem] = useState(pathpart);
    const [openMenu, setOpenMenu] = useState(null);
    const [subActive, setSubActive] = useState(null);

    const [hoverState, setHoverState] = useState({
        row: null,
        plus: null,
    });
    const [hoveredItem, setHoveredItem] = useState(null);

    const navigate = useNavigate();

    const handleSelectedItem = (newvalue) => {
        if (newvalue) {
            setSelectedItem(newvalue);
            if (newvalue === "Manage" || newvalue === "Manage Dating") {
            } else {
                navigate(`/${newvalue}`);
            }
        }
    };

    const handleMenuClick = (menuName, hasSubMenu) => {
        if (hasSubMenu) {
            handleSelectedItem(menuName);
            setOpenMenu(openMenu === menuName ? null : menuName);
        } else {
            handleSelectedItem(menuName);
        }
    };

    const handleActive = (sub) => {
        setSubActive(sub);
    };

    return (
        <Box bgcolor='white' position='relative' className='h-100 sidemenue' width='20%' maxWidth='250px'>
            <Box height='64px' className='logo px-3 px-lg-5 py-3'>
                <img src={Icons.Ic_logo} width='100%' alt="" />
            </Box>

            <Box className='p-3'>
                <Box className='dashboard-menue'>
                    <Box className='my-2 w-100'>
                        {menue.map((item) => (
                            <Box key={item.menueName} className="w-100">
                                <Box
                                    onClick={() => handleMenuClick(item.menueName, !!item.subMenu)}
                                    onMouseEnter={() => setHoveredItem(item.menueName)}
                                    onMouseLeave={() => setHoveredItem(null)}
                                    sx={{
                                        borderRadius: '10px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        p: 1,
                                        mb: 1,
                                        color: selectedItem === item.menueName ? 'white' : 'inherit',
                                        bgcolor: selectedItem === item.menueName ? 'black' : 'transparent',
                                        '&:hover': { bgcolor: 'black', color: "white" }
                                    }}
                                >
                                    <img
                                        height='24px'
                                        src={require(`../../Assets/Images/SideMenueIcons/${selectedItem === item.menueName || hoveredItem === item.menueName
                                            ? item.selectedLogo
                                            : item.defaultLogo
                                            }`)}
                                        alt=''
                                    />
                                    <Typography>{item.menueName}</Typography>
                                </Box>

                                {item.subMenu && openMenu === item.menueName && (
                                    <Box
                                        pl={2}
                                        pr={2}
                                        display="flex"
                                        flexDirection="column"
                                        gap={1}
                                        sx={{
                                            maxHeight: "40vh",
                                            overflowY: "auto",
                                            "&::-webkit-scrollbar": { width: "5px" },
                                            "&::-webkit-scrollbar-thumb": { backgroundColor: "black", borderRadius: "6px" },
                                            "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#555" },
                                        }}
                                    >
                                        {item.subMenu.map((sub) => {
                                            const isRowHover = hoverState.row === sub.menueName;
                                            const isPlusHover = hoverState.plus === sub.menueName;
                                            const isActive = subActive === sub.menueName;

                                            return (
                                                <Typography
                                                    key={sub.menueName}
                                                    sx={{
                                                        cursor: "pointer",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        padding: "7px 10px",
                                                        marginLeft: "10px",
                                                        fontSize: "0.85rem",
                                                        borderRadius: "6px",
                                                        transition: "all 0.3s ease",
                                                        backgroundColor: isPlusHover
                                                            ? "white"
                                                            : isRowHover || isActive
                                                                ? "black"
                                                                : "transparent",
                                                        color: isPlusHover
                                                            ? "black"
                                                            : isRowHover || isActive
                                                                ? "white"
                                                                : "black",
                                                    }}
                                                    onMouseEnter={() => setHoverState({ row: sub.menueName, plus: null })}
                                                    onMouseLeave={() => setHoverState({ row: null, plus: null })}
                                                    onClick={() => {
                                                        handleActive(sub.menueName);
                                                        navigate(`/${sub.url}`);
                                                    }}
                                                    component="div"      // <-- render as div

                                                >
                                                    <div
                                                        onClick={() => {
                                                            navigate(`/${sub.url}`);
                                                            // dispatch(clearShowMenu());
                                                        }}
                                                    >
                                                        {sub.menueName}
                                                    </div>

                                                    {sub.plus && (
                                                        <button
                                                            style={{
                                                                backgroundColor: isPlusHover ? "black" : "#fff",
                                                                color: isPlusHover ? "white" : "black",
                                                                border: "none",
                                                                borderRadius: "50%",
                                                                width: "20px",
                                                                height: "20px",
                                                                fontSize: "18px",
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                transition: "all 0.3s ease",
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.stopPropagation();
                                                                setHoverState({ row: sub.menueName, plus: sub.menueName });
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.stopPropagation();
                                                                setHoverState({ row: sub.menueName, plus: null });
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                navigate(`/admin/${sub.url}`);
                                                                // dispatch(setShowMenu(`${sub.menueName}`));
                                                            }}
                                                        >
                                                            +
                                                        </button>
                                                    )}
                                                </Typography>
                                            );
                                        })}
                                    </Box>
                                )}

                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default Menue;
